
  export const getAnimalSpeciesLabel = name => {
    const species = {
      dog: "Hund",
      cat: "Katze",
      rabbit: "Kaninchen",
      ginnypig: "Meerschweinchen"
    };

    return Object.entries(species).map(([key, value]) => {
      if (key === name) {
        return value;
      }
    });
  };

  export const getGeneralConditionLabel = name => {
    const condition = {
      none: "nicht auffällig",
      noReaction:
        "reagiert nicht auf Ansprache oder sanftes anstupsen oder reagiert zwar, aber ist überhaupt nicht in Lage aufzustehen.",
      notWalking: "ist nicht in der Lage mehrere Schritte ohne Unterstützung zu gehen",
      irregularBehavior: "ist deutlich ruhiger oder unruhiger als sonst",
      notNoticeable: "der Allgemeinzustand ist nicht auffällig"
    };

    return Object.entries(condition).map(([key, value]) => {
      if (key === name) {
        return value;
      }
    });
  };

  export const getBodyTempLabel = name => {
    const bodyTempLabels = {
      0: "Nicht bestimmt",
      1: "<37,0 ℃",
      2: "37-39,1 ℃",
      3: "39,1-39,6 ℃",
      4: ">39,6 ℃"
    };

    return Object.entries(bodyTempLabels).map(([key, value]) => {
      if (parseInt(key) === name) {
        return value;
      }
    });
  };

  export const getGlandColorLabel = name => {
    const glandColorLabels = {
      "nicht bestimmt": "Nicht bestimmt",
      Rosa: "Rosa",
      weakRosa: "Blass Rosa",
      red: "Rötlich",
      blue: "Bläulich",
      porcelainWhite: "Porzellanweiß"
    };

    return Object.entries(glandColorLabels).map(([key, value]) => {
      if (key === name) {
        return value;
      }
    });
  };

  export const getBreathFreqLabel = name => {
    const breathFreqLabels = {
      0: "Nicht bestimmt",
      1: "Nicht zählbar, da Tier ununterbrochen hechelt",
      2: "<30/min",
      3: "30-40/min",
      4: ">40/min"
    };

    return Object.entries(breathFreqLabels).map(([key, value]) => {
      if (parseInt(key) === name) {
        return value;
      }
    });
  };

  export const getDrinkingBehaviorLabel = name => {
    const drinkingBehaviorLabels = {
      1: "Normal",
      2: "Mehr",
      3: "Weniger",
      4: "Überhaupt nicht"
    };

    return Object.entries(drinkingBehaviorLabels).map(([key, value]) => {
      if (parseInt(key) === name) {
        return value;
      }
    });
  };

  export const getDrinkingSinceLabel = name => {
    const drinkingSinceLabels = {
      1: "Mehr als 6 Stunden",
      2: "Mehr als 12 Stunden",
      3: "Mehr als 24 Stunden"
    };

    return Object.entries(drinkingSinceLabels).map(([key, value]) => {
      if (parseInt(key) === name) {
        return value;
      }
    });
  };

  export const getEatingBehaviorLabel = name => {
    const drinkingBehaviorLabels = {
      1: "Normal",
      2: "Mehr",
      3: "Weniger",
      4: "Überhaupt nicht"
    };

    return Object.entries(drinkingBehaviorLabels).map(([key, value]) => {
      if (parseInt(key) === name) {
        return value;
      }
    });
  };

  export const getEatingSinceLabel = name => {
    const drinkingSinceLabels = {
      1: "Mehr als 6 Stunden",
      2: "Mehr als 12 Stunden",
      3: "Mehr als 24 Stunden"
    };

    return Object.entries(drinkingSinceLabels).map(([key, value]) => {
      if (parseInt(key) === name) {
        return value;
      }
    });
  };

  export const getUrineBehaviorLabel = name => {
    const urineBehaviorLabels = {
      1: "Normal",
      2: "Weniger oder Mehr",
      3: "Häufiger aber nur wenig",
      4: "Kein"
    };

    return Object.entries(urineBehaviorLabels).map(([key, value]) => {
      if (parseInt(key) === name) {
        return value;
      }
    });
  };

  export const getUrineSinceLabel = name => {
    const urineSinceLabels = {
      1: "Mehr als 6 Stunden",
      2: "Mehr als 12 Stunden",
      3: "Mehr als 24 Stunden"
    };

    return Object.entries(urineSinceLabels).map(([key, value]) => {
      if (parseInt(key) === name) {
        return value;
      }
    });
  };

  export const getDroppingsBehaviorLabel = name => {
    const droppingsBehaviorLabels = {
      1: "Normal",
      2: "Kein Kotabsatz",
      3: "breiig",
      4: "flüssig"
    };

    return Object.entries(droppingsBehaviorLabels).map(([key, value]) => {
      if (parseInt(key) === name) {
        return value;
      }
    });
  };

  export const getDroppingsSinceLabel = name => {
    const droppingsSinceLabels = {
      1: "Mehr als 12 Stunden",
      2: "Mehr als 24 Stunden",
      3: "Mehr als 48 Stunden"
    };

    return Object.entries(droppingsSinceLabels).map(([key, value]) => {
      if (parseInt(key) === name) {
        return value;
      }
    });
  };

  export const getVomitingBehaviorLabel = name => {
    const vomitingBehaviorLabels = {
      1: "Normal",
      2: "Gelegentlich",
      3: "ständig",
      4: "behält nichts bei sich"
    };

    return Object.entries(vomitingBehaviorLabels).map(([key, value]) => {
      if (parseInt(key) === name) {
        return value;
      }
    });
  };

  export const getVomitingSinceLabel = name => {
    const vomitingSinceLabels = {
      1: "Mehr als 12 Stunden",
      2: "Mehr als 24 Stunden",
      3: "Mehr als 48 Stunden"
    };

    return Object.entries(vomitingSinceLabels).map(([key, value]) => {
      if (parseInt(key) === name) {
        return value;
      }
    });
  };
